export const labels = {
	clear: {
		label: "Label.MobileCreator.BottomMenu.Text.Clear",
		default: "Clear",
		// description: "The clears the content of the text zone. It does NOT delete the text zone"
	},
	delete: {
		label: "Label.MobileCreator.BottomMenu.Text.Delete",
		default: "Delete",
	},
	edit: {
		label: "Label.MobileCreator.BottomMenu.Text.Edit",
		default: "Edit",
	},
	font: {
		label: "Label.MobileCreator.BottomMenu.Text.Font",
		default: "Font",
	},
	textSize: {
		label: "Label.MobileCreator.BottomMenu.Text.Textsize",
		default: "Size",
	},
	textColor: {
		label: "Label.MobileCreator.BottomMenu.Text.FontColour",
		default: "Color",
	},
	alignment: {
		label: "Label.MobileCreator.BottomMenu.Text.Alignment",
		default: "Alignment",
	},
	textStyle: {
		label: "Label.MobileCreator.BottomMenu.Text.TextStyle",
		default: "Style",
	},
	addTextZone: {
		label: "Label.MobileCreator.BottomMenu.Text.AddZone",
		default: "Add text",
	},
	selectTextZoneFirst: {
		label: "Label.MobileCreator.BottomMenu.Text.SelectTextZoneFirst",
		default: "Select a text zone first",
	},
	textPosition: {
		label: "Label.MobileCreator.BottomMenu.Zone.Position",
		default: "Position",
	},
};
